var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('singleDateForm',{attrs:{"label":_vm.$t('inspections.tableHeader.inspectionDate'),"data-cy":"inspectionDate","prependIcon":"event","rules":_vm.requieredRule},model:{value:(_vm.value.inspectionDate),callback:function ($$v) {_vm.$set(_vm.value, "inspectionDate", $$v)},expression:"value.inspectionDate"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }